module.exports = __webpack_public_path__ + "img/sdk2.708610a4.png";